export const APPOINTMENT_STATE_CONFIG = {
  libre:       { color: '#546e7a', muiColor: 'default', label: 'Libre / Bloqueado' },
  pendiente:   { color: '#ef5350', muiColor: 'error',   label: 'Pendiente' },
  confirmado:  { color: '#ffb300', muiColor: 'warning', label: 'Confirmado' },
  // El médico ya llamó al paciente desde la sala de espera y lo está
  // atendiendo ahora mismo — pedido explícito del usuario (2026-11-04).
  // Verde: ningún otro estado lo usa.
  en_consulta: { color: '#2e7d32', muiColor: 'success', label: 'En consulta' },
  cancelado:   { color: '#616161', muiColor: 'default', label: 'Cancelado' },
  ausente:     { color: '#ff6d00', muiColor: 'warning', label: 'Ausente' },
  atendido:    { color: '#1565c0', muiColor: 'info',    label: 'Atendido' },
  ocupado:     { color: '#ef5350', muiColor: 'error',   label: 'Pendiente' }, // legacy
};

export const APPOINTMENT_STATE_OPTIONS = [
  { value: 'pendiente',   label: 'Pendiente',         hint: 'turno asignado, sin confirmar' },
  { value: 'confirmado',  label: 'Confirmado',        hint: 'el paciente confirmó que viene' },
  { value: 'en_consulta', label: 'En consulta',       hint: 'el médico ya lo llamó y lo está atendiendo' },
  { value: 'cancelado',   label: 'Cancelado',         hint: 'no viene, slot disponible' },
  { value: 'ausente',     label: 'Ausente',           hint: 'no vino sin avisar' },
  { value: 'atendido',    label: 'Atendido',          hint: 'consulta realizada' },
  { value: 'libre',       label: 'Libre / Bloqueado', hint: 'sin paciente asignado' },
];
